import React from 'react';
import Aux from '../hoc/Aux';
import TextTermsOfUse from './Shared/TextTermsOfUse';

const termsOfUse = (props) => (
  <Aux>
    <div className="main-container">
       <div className="container">
          <div className="row justify-content-center">
             <div className="col-lg-11 col-xl-10">
              <TextTermsOfUse />
             </div>
          </div>
       </div>
    </div>
  </Aux>
);

export default termsOfUse;



// WEBPACK FOOTER //
// ./src/components/TermsOfUse.js